import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
const getAdminGiveawaysPayloadSchema = {
    type: 'object',
    properties: {
        filters: {
            type: 'object',
            properties: {
                userId: {
                    type: 'string',
                },
                status: {
                    type: 'string',
                    enum: ['PUBLISHED', 'ACTIVE', 'RESOLVED'],
                },
            },
        },
        sort: {
            type: 'object',
            properties: {
                field: {
                    type: 'string',
                },
                order: {
                    type: 'string',
                    enum: ['ASC', 'DESC'],
                },
            },
        },
        pagination: {
            type: 'object',
            properties: {
                page: {
                    type: 'integer',
                },
                limit: {
                    type: 'integer',
                },
            },
        },
    },
};
export const getAdminGiveawaysEndpoint = {
    [giveawayEndpointIds.GET_ADMIN_GIVEAWAYS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: getAdminGiveawaysPayloadSchema,
    },
};
